module.exports = __webpack_public_path__ + "img/fig20.645dc818.jpg";